import { getRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
import _ from "lodash";

import { SOCIALFEED_TOTAL_POST } from "SocialfeedPostAction";
import { SOCIALFEED_TOTAL_REACTION } from "SocialfeedReactionAction";
import { SOCIALFEED_TOTAL_COMMENT } from "SocialfeedCommentAction";
import { SOCIALFEED_TOTAL_MEDIA } from "SocialfeedMediaAction";
import { SOCIALFEED_TOTAL_POLL } from "SocialfeedPollAction";

export var SOCIALFEED_POST = "SOCIALFEED_POST";
export var SOCIALFEED_REACTION = "SOCIALFEED_REACTION";
export var SOCIALFEED_COMMENT = "SOCIALFEED_COMMENT";
export var SOCIALFEED_MEDIA = "SOCIALFEED_MEDIA";
export var SOCIALFEED_POLL = "SOCIALFEED_POLL";

export var SOCIALFEED_SELECTED_ITEM = "SOCIALFEED_SELECTED_ITEM";
export var SOCIALFEED_ITEM_SELECTED = "SOCIALFEED_ITEM_SELECTED"; // main
export var SOCIALFEED_TOUSERS_ENGAGE = "SOCIALFEED_TOUSERS_ENGAGE";
export var SOCIALFEED_POSTYPES_PAICHART = "SOCIALFEED_POSTYPES_PAICHART";

export function onSocialfeedMenuSelected(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: SOCIALFEED_ITEM_SELECTED, payload: selectedMenu });
  };
}

// Socialfeed Engagement (top users who were active on socialfeed app)
const fetchTopSocialfeedEngagementTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=socialfeedenga&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Top session Table data (List) Installs..
        dispatch({ type: SOCIALFEED_TOUSERS_ENGAGE, data: data.resource });
        callback({
          error: 0,
          data: "Analytics Socialfeed Engagement Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export function dispatchAnalyticsData(data) {
  return (dispatch) => {
    //dispatch({type: SOCIALFEED_TOTAL_POST, payload: {count:data}}); count:data.devices.count
    dispatch({ type: SOCIALFEED_TOTAL_POST, payload: { count: data } });
    dispatch({ type: SOCIALFEED_TOTAL_REACTION, payload: { count: data } });
    dispatch({ type: SOCIALFEED_TOTAL_COMMENT, payload: { count: data } });
    dispatch({ type: SOCIALFEED_TOTAL_MEDIA, payload: { count: data } });
    dispatch({ type: SOCIALFEED_TOTAL_POLL, payload: { count: data } });
  };
}

// Socialfeed Posting types [clacification for socialfeed post paichart]
const fetchSocialfeedPostypePaichart = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=postypepaichart&eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response.resource;

        var numDataCount = data.length;
        var postingPaiChartData = [];

        data.map((value, index) => {
          postingPaiChartData.push({
            name: `${_.upperFirst(value.Name)}`,
            value: parseInt(value.totcount),
          });
        });

        dispatch({
          type: SOCIALFEED_POSTYPES_PAICHART,
          payload: postingPaiChartData,
        });
        callback({
          error: 0,
          data: "Socialfeed Analytics Posting type Data Fetched",
        });
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
};

export {
  fetchTopSocialfeedEngagementTableData,
  fetchSocialfeedPostypePaichart,
};
